export default __webpack_public_path__ + "static/media/info-dark-icon.3c7dfb2e.svg";